// The little reference text on a point's citation row (Delivery.jsx).
//
// A quote point's reference used to live inside the quote box's own footer,
// styled like the end of a sentence, so it carried a trailing period ("Sidan
// 7, avsnittet om byggprognoserna."). A point with no quote never had a
// footer to sit in - its citationShort has always been shown bare, with no
// period added. Now both kinds of point share one citation row, so this is
// the one place that decides which look a given point gets, instead of the
// rule living twice at the call site.
export function citationRefText(citationShort, hasQuote) {
  return hasQuote ? `${citationShort}.` : citationShort;
}
